import { memo } from 'react';
import { ModalExtendedProps } from '@bonanza-social/navigation';
import StatusModal from '../components/StatusModal/StatusModal';
import StatusDemotion from '../components/StatusDemotion/StatusDemotion';

function StatusDemotionModal({ close }: ModalExtendedProps) {
  return (
    <StatusModal close={close}>
      <StatusDemotion flex={1} onButtonPress={close} />
    </StatusModal>
  );
}

export default memo(StatusDemotionModal);
